import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL } from '@app/core/constants';
import { Observable } from 'rxjs';
import { IMember } from '@core/model';
import { ApplicationStateService } from './application-state.service';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly applicationStateService: ApplicationStateService,
    @Inject(API_URL) private readonly apiUrl: string
  ) {}

  getMemberBySubscriberNumber(subscriberNumber: string): Observable<IMember> {
    const url = `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}/Member/GetMemberSearchBySubscriberNumber/${subscriberNumber}`;
    return this.httpClient.get<IMember>(url);
  }
}
